/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const downloadReadableStream = async (
  readableStrem: any,
  filename: string,
): Promise<void> => {
  const blob = await readableStrem.blob();
  const newBlob = new Blob([blob]);

  const blobUrl = window.URL.createObjectURL(newBlob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', `${filename}.${'pdf'}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);

  window.URL.revokeObjectURL(`${blob}`);
};

export const downloadBase64File = (
  base64: string,
  filename: string,
  contentType = 'application/vnd.ms-excel',
): void => {
  const binary = atob(base64);
  const buffer = new ArrayBuffer(binary.length);
  const view = new Uint8Array(buffer);

  for (let i = 0; i < binary.length; i += 1) {
    view[i] = binary.charCodeAt(i);
  }

  const blobUrl = window.URL.createObjectURL(
    new Blob([view], { type: contentType }),
  );

  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', filename);
  link.click();

  window.URL.revokeObjectURL(blobUrl);
};

export const openInNewTab = async (readableStream) => {
  const blob = await readableStream.blob();

  const blobUrl = URL.createObjectURL(blob);

  const newTab = window.open(blobUrl, '_blank');

  if (newTab) {
    newTab.addEventListener('beforeunload', () => {
      window.URL.revokeObjectURL(blobUrl);
    });
  }
};
